import { createBrowserRouter } from "react-router-dom";

import App from "./App";
import { RouteError } from "./components/RouteError";
import { CounterpartiesPage } from "./pages/CounterpartiesPage";
import { Dashboard } from "./pages/Dashboard";
import { MarketPage } from "./pages/MarketPage";
import { NotFound } from "./pages/NotFound";
import { RebatesPage } from "./pages/RebatesPage";
import { SignalsPage } from "./pages/SignalsPage";
import { TradesPage } from "./pages/TradesPage";
import { WalletPage } from "./pages/WalletPage";

/**
 * Маршруты торгового окна.
 *
 * errorElement висит на ДОЧЕРНИХ маршрутах, а не на макете. Ошибка внутри
 * страницы заменяет содержимое Outlet, но макет остаётся смонтированным — а
 * вместе с ним шапка, индикатор связи и эффект, держащий сокет с подписками.
 * Повесь errorElement на макет, и одна битая страница уносила бы соединение,
 * то есть ровно то, что веха обязана сохранять.
 *
 * basename не нужен: UI отдаётся из корня, а nginx уже возвращает index.html
 * на любой путь (try_files).
 */
export const router = createBrowserRouter([
  {
    element: <App />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <Dashboard />, errorElement: <RouteError /> },
      { path: "market/:conditionID", element: <MarketPage />, errorElement: <RouteError /> },
      // Профиль кошелька-контрагента (веха M6). Строго ПЕРЕД "*", иначе
      // catch-all перехватил бы его первым и страница никогда не открылась бы.
      { path: "wallet/:address", element: <WalletPage />, errorElement: <RouteError /> },
      // История наших сделок. Фильтры живут в query (?market=&wallet=&hours=),
      // а не в пути: ссылку на «все сделки с этим кошельком» тогда можно дать
      // со страницы профиля и из ленты, не заводя второго маршрута.
      { path: "trades", element: <TradesPage />, errorElement: <RouteError /> },
      // Свод встреч по КОШЕЛЬКАМ — тот же журнал, что у /trades, но другой
      // вопрос: не «что было в этой сделке», а «кто принимает мои ставки».
      // Фильтры в query (?market=&hours=) по той же причине, что у истории.
      {
        path: "counterparties",
        element: <CounterpartiesPage />,
        errorElement: <RouteError />,
      },
      // Тир программы возврата тейкерской комиссии. Без параметров в пути и в
      // query: адрес берёт сервер, а окно задаёт сама биржа — выбирать
      // оператору здесь нечего, и фильтр предлагал бы обратное.
      { path: "rebates", element: <RebatesPage />, errorElement: <RouteError /> },
      // Копирование ставок умных кошельков: сводка двух гипотез и лента
      // сигналов. Карточки живых сигналов при этом видны с ЛЮБОЙ страницы —
      // они в макете, а не здесь (см. App.tsx).
      { path: "signals", element: <SignalsPage />, errorElement: <RouteError /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
